import NewsletterSuccess from './NewsletterSuccess'

export default NewsletterSuccess
